import React from 'react';
import ProductOverview from '../../product-overview/ProductOverview';
import product from '../all-gear.json';

const MenNikeFullZipSweatshirt = () => {
	return (
		<React.Fragment>
			<ProductOverview
				name={product.allGear[4].productName}
				color={product.allGear[4].color}
				size={product.allGear[4].sizes}
				price={product.allGear[4].price}
				img={product.allGear[4].img}
				miniImg1={product.allGear[4].miniImg1}
				miniImg2={product.allGear[4].miniImg2}
				miniImg3={product.allGear[4].miniImg3}
			/>
		</React.Fragment>
	);
};

export default MenNikeFullZipSweatshirt;
